import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../../services/firebase';

function SuperAdminRoute({ children }) {
  const [user, loading] = useAuthState(auth);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [userClubId, setUserClubId] = useState(null);
  const [checkingRole, setCheckingRole] = useState(true);

  useEffect(() => {
    const checkSuperAdmin = async () => {
      if (!user) {
        setCheckingRole(false);
        return;
      }

      try {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setIsSuperAdmin(userData.role === 'super_admin');
          setUserClubId(userData.clubId || null);
        }
      } catch (error) {
        console.error('Error checking super admin status:', error);
      } finally {
        setCheckingRole(false);
      }
    };

    if (user) {
      checkSuperAdmin();
    } else if (!loading) {
      setCheckingRole(false);
    }
  }, [user, loading]);

  if (loading || checkingRole) {
    return (
      <div className="admin-loading">
        <div className="admin-loading-content">
          <span className="loading-icon">⚽</span>
          <p>Verifying access...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin" replace />;
  }

  if (!isSuperAdmin) {
    return (
      <div className="admin-loading">
        <div className="admin-loading-content">
          <span className="loading-icon">🚫</span>
          <h2>Access Denied</h2>
          <p>You do not have super admin privileges.</p>
          {userClubId ? (
            <a href={`/admin/dashboard?club=${userClubId}`} className="btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>
              Go to Club Dashboard
            </a>
          ) : (
            <a href="/" className="btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>
              Go to Home
            </a>
          )}
        </div>
      </div>
    );
  }

  return children;
}

export default SuperAdminRoute;
